import "./CalificarMisMedicos.css";
import HeaderModal from "../headerModal/headerModal";
import { useContext, useEffect, useRef, useState } from "react";
import { FaStar } from "react-icons/fa";
import { PortalContext } from "../../../context/Provider";
import {
  misMedicosResetEncuesta,
  wsPostMisMedicos,
  wsPutMisMedicos,
} from "../../../context/Actions/misMedicos/misMedicos";
import { hideModal } from "../../../context/Actions/modal/modal";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { IonSpinner } from "@ionic/react";
import camelize from "../../../../global/utils/camelize";
import { loginTokenReset } from "../../../context/Actions/token/loginToken";
import { logoutAuth } from "../../../../global/context/action/auth/login";
import { useHistory } from "react-router";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../InputV1/InputV1";

const CalificarMisMedicos = ({
  titulo,
  item,
  estrellas_medico_actual,
  estrellas_recepcion_actual,
  estrellas_tecnico_actual,
  detalle_medico_actual,
  detalle_recepcion_actual,
  detalles_tecnico_actual,
  recargarEstudios,
  flgEncuestaToken,
}) => {
  const trackButton = useRef();
  let fechaToday = new Date();
  const stars = Array(5).fill(0);

  const starColor = {
    dorado: "#edce00",
    azul: "#0072B3",
    gris: "#E6E6E6",
  };

  const {
    modalDispatch,
    misMedicosDispatch,
    misMedicosState,
    tokenDispatch,
    tokenState,
  } = useContext(PortalContext);

  // Nuevo contexto
  const { authDispatch, toasterDispatch } = useContext(GlobalContext);

  const history = useHistory();
  const [valorActualRecepcionista, setValorActualRecepcionista] = useState(
    estrellas_recepcion_actual
  );
  const [valorActualMedico, setValorActualMedico] = useState(
    estrellas_medico_actual
  );
  const [valorActualTecnico, setValorActualTecnico] = useState(
    estrellas_tecnico_actual
  );
  const [hoverValueRecepcionista, setHoverValueRecepcionista] =
    useState(undefined);
  const [hoverValueMedico, setHoverValueMedico] = useState(undefined);
  const [hoverValueTecnico, setHoverValueTecnico] = useState(undefined);
  const [btnDisabled, setBtnDisabled] = useState(true);

  const [formularioCalificacion, setFormularioCalificacion] = useState({
    idTurno: item.idProtocolo > 0 ? -1 : item.idTurno,
    idProtocolo: item.idProtocolo,
    fechaPost: fechaToday,
    estrellas_recepcion: valorActualRecepcionista,
    estrellas_medico: estrellas_medico_actual ? valorActualMedico : -1,
    estrellas_tecnico: estrellas_tecnico_actual ? valorActualTecnico : -1,
    detalles_recepcion: detalle_recepcion_actual,
    detalles_tecnico: detalles_tecnico_actual,
    detalles_medico: detalle_medico_actual,
    accion: item.idProtocolo > 0 ? 16 : 0,
  });

  const handleMouseOverRecepcionista = (estrellasRecepcionista) => {
    setHoverValueRecepcionista(estrellasRecepcionista);
  };
  const handleMouseLeaveRecepcionista = () => {
    setHoverValueRecepcionista(undefined);
  };

  const handleMouseOverMedico = (estrellasMedico) => {
    setHoverValueMedico(estrellasMedico);
  };

  const handleMouseLeaveMedico = () => {
    setHoverValueMedico(undefined);
  };

  const handleMouseOverTecnico = (estrellasTecnico) => {
    setHoverValueTecnico(estrellasTecnico);
  };

  const handleMouseLeaveTecnico = () => {
    setHoverValueTecnico(undefined);
  };

  const onChangeDetalles = (e) => {
    if (e.target.name.length === 0) {
      setFormularioCalificacion({
        ...formularioCalificacion,
        [e.target.name]: "",
      });
    } else {
      setFormularioCalificacion({
        ...formularioCalificacion,
        [e.target.name]: e.target.value,
      });
    }
  };

  const calificarRecepcionista = (estrellasRecepcionista) => {
    setValorActualRecepcionista(estrellasRecepcionista);
    setFormularioCalificacion({
      ...formularioCalificacion,
      estrellas_recepcion: estrellasRecepcionista,
    });
  };

  const calificarMedico = (estrellasMedico) => {
    setValorActualMedico(estrellasMedico);
    setFormularioCalificacion({
      ...formularioCalificacion,
      estrellas_medico: estrellasMedico,
    });
  };

  const calificarTecnico = (estrellasTecnico) => {
    setValorActualTecnico(estrellasTecnico);
    setFormularioCalificacion({
      ...formularioCalificacion,
      estrellas_tecnico: estrellasTecnico,
    });
  };

  const enviarCalificaciones = () => {
    if (
      valorActualRecepcionista === 0 ||
      (valorActualMedico === 0 && valorActualTecnico === 0)
    ) {
      showToaster(
        {
          texto: "Debe calificar a ambas partes para continuar",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      wsPostMisMedicos(formularioCalificacion, encuestaRta)(misMedicosDispatch);
    }
  };

  const modificarCalificacion = () => {
    if (
      valorActualMedico === estrellas_medico_actual &&
      valorActualRecepcionista === estrellas_recepcion_actual &&
      valorActualTecnico === estrellas_tecnico_actual &&
      formularioCalificacion.detalles_recepcion === detalle_recepcion_actual &&
      formularioCalificacion.detalles_medico === detalle_medico_actual &&
      formularioCalificacion.detalles_tecnico === detalles_tecnico_actual
    ) {
      showToaster(
        {
          texto: "Debe cambiar la calificación para continuar",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      wsPutMisMedicos(
        item.idTurno,
        formularioCalificacion,
        encuestaRta
      )(misMedicosDispatch);
    }
  };

  const encuestaRta = (isCorrect, data) => {
    if (isCorrect) {
      showToaster(
        {
          texto: "Encuesta realizada correctamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      misMedicosResetEncuesta()(misMedicosDispatch);
      loginTokenReset()(tokenDispatch);
      hideModal()(modalDispatch);
      if (!flgEncuestaToken) {
        recargarEstudios();
      }
    } else {
      showToaster(
        {
          texto: data ? data : "Error al realizar encuesta",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      if (flgEncuestaToken) {
        hideModal()(modalDispatch);
      }
    }
  };

  const dissmiss = () => {
    loginTokenReset()(tokenDispatch);
    hideModal()(modalDispatch);
  };

  //cierro modal y limpio los estados globales
  useEffect(() => {
    return () => {
      if (tokenState.token.data !== null) {
        if (tokenState.token.data.origen === "tokenURL") {
          logoutAuth()(authDispatch);
          history.push("/");
        }
      }
      loginTokenReset()(tokenDispatch);
    };
  }, []);

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} danger={false} />
      <div className="ptur-misMedicos-modalBody" ref={trackButton}>
        <div className="ptur-misMedicos-modal-recepcionista-medico">
          <div className="ptur-misMedicos-modal-recepcionista">
            <div className="ptur-misMedicos-modal-titulo">
              <p>Recepcionista</p>
              {item.recepcionista ? (
                <div className="rb18m">{camelize(item.recepcionista)}</div>
              ) : (
                ""
              )}
            </div>
            <div className="ptur-misMedicos-estrellas-container">
              {stars.map((_, index) => {
                return (
                  <div
                    key={index}
                    className={
                      (hoverValueRecepcionista || valorActualRecepcionista) >
                      index
                        ? "ptur-misMedicos-estrellas-dorado"
                        : "ptur-misMedicos-estrellas-modal"
                    }
                    onClick={() => calificarRecepcionista(index + 1)}
                    onMouseOver={() => handleMouseOverRecepcionista(index + 1)}
                    onMouseLeave={handleMouseLeaveRecepcionista}
                  >
                    <FaStar
                      key={index}
                      size={24}
                      color={
                        (hoverValueRecepcionista || valorActualRecepcionista) >
                        index
                          ? starColor.dorado
                          : starColor.gris
                      }
                      style={{
                        stroke: "black", // Color del borde
                        strokeWidth: "20px", // Grosor del borde
                      }}
                    />
                  </div>
                );
              })}
            </div>
            <div className="ptur-misMedicos-modalTextarea">
              <InputV1
                disabledEjemplo={true}
                className="ptur-misMedicos-textarea"
                name="detalles_recepcion"
                placeholderText={
                  "Deje aquí sus comentarios sobre la atención recibida"
                }
                maxLength={480}
                inputType="textarea"
                onChange={onChangeDetalles}
                value={formularioCalificacion.detalles_recepcion}
              />
            </div>
          </div>

          {item.tecnico !== null && item.tecnico !== "" ? (
            <>
              <div className="ptur-misMedicos-modal-medico">
                <div className="ptur-misMedicos-modal-titulo">
                  <p>Técnico</p>
                  <div className="rb18m">{camelize(item.tecnico)}</div>
                </div>
                <div className="ptur-misMedicos-estrellas-container">
                  {stars.map((_, index) => {
                    return (
                      <div
                        key={index}
                        className={
                          (hoverValueTecnico || valorActualTecnico) > index
                            ? "ptur-misMedicos-estrellas-dorado"
                            : "ptur-misMedicos-estrellas-modal"
                        }
                        onClick={() => calificarTecnico(index + 1)}
                        onMouseOver={() => handleMouseOverTecnico(index + 1)}
                        onMouseLeave={handleMouseLeaveTecnico}
                      >
                        <FaStar
                          key={index}
                          size={24}
                          color={
                            (hoverValueTecnico || valorActualTecnico) > index
                              ? starColor.dorado
                              : starColor.gris
                          }
                          style={{
                            stroke: "black", // Color del borde
                            strokeWidth: "20px", // Grosor del borde
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
                <div className="ptur-misMedicos-modalTextarea">
                  <InputV1
                    disabledEjemplo={true}
                    inputType="textarea"
                    name="detalles_tecnico"
                    placeholderText="Deje aquí sus comentarios sobre la atención recibida"
                    maxLength={480}
                    onChange={onChangeDetalles}
                    value={formularioCalificacion.detalles_tecnico}
                    className="ptur-misMedicos-textarea"
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              {item.medico !== "" && item.medico !== null && (
                <div className="ptur-misMedicos-modal-medico">
                  <div className="ptur-misMedicos-modal-titulo">
                    <p>Médico</p>
                    <div className="rb18m">{camelize(item.medico)}</div>
                  </div>
                  <div className="ptur-misMedicos-estrellas-container">
                    {stars.map((_, index) => {
                      return (
                        <div
                          key={index}
                          className={
                            (hoverValueMedico || valorActualMedico) > index
                              ? "ptur-misMedicos-estrellas-dorado"
                              : "ptur-misMedicos-estrellas-modal"
                          }
                          onClick={() => calificarMedico(index + 1)}
                          onMouseOver={() => handleMouseOverMedico(index + 1)}
                          onMouseLeave={handleMouseLeaveMedico}
                        >
                          <FaStar
                            key={index}
                            size={24}
                            color={
                              (hoverValueMedico || valorActualMedico) > index
                                ? starColor.dorado
                                : starColor.gris
                            }
                            style={{
                              stroke: "black", // Color del borde
                              strokeWidth: "20px", // Grosor del borde
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="ptur-misMedicos-modalTextarea">
                    <InputV1
                      disabledEjemplo={true}
                      inputType="textarea"
                      name="detalles_medico"
                      placeholderText="Deje aquí sus comentarios sobre la atención recibida"
                      maxLength={480}
                      onChange={onChangeDetalles}
                      value={formularioCalificacion.detalles_medico}
                      className="ptur-misMedicos-textarea"
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <div className="ptur-misMedicos-botones-container">
        <button
          className="ptur-misMedicos-boton-cancelar b-latex30 rb16m c-latex30 bgc-white"
          onClick={() => dissmiss()}
        >
          Cancelar
        </button>
        <button
          className={
            btnDisabled || misMedicosState.misMedicos.loading
              ? "ptur-misMedicos-boton-enviar bgc-latex10 c-white"
              : "ptur-misMedicos-boton bgc-grey65 c-white"
          }
          onClick={
            misMedicosState.misMedicos.loading
              ? () => {}
              : item.encuesta === null
              ? () => enviarCalificaciones()
              : () => modificarCalificacion()
          }
        >
          {misMedicosState.misMedicos.loading ? (
            <div className="ptur-loading">
              <IonSpinner name="lines" />
            </div>
          ) : (
            "Enviar"
          )}
        </button>
      </div>
    </>
  );
};

export default CalificarMisMedicos;
